module.exports = __webpack_public_path__ + "img/12-green.b88a7e5f.svg";